import JEditableTable from '@/components/jeecg/JEditableTable'
import { VALIDATE_NO_PASSED, getRefPromise, validateFormAndTables, validateTables } from '@/utils/JEditableTableUtil'
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { getLanguageField } from '@/utils/langUtils'

export const JEditableTableMixin = {
  components: {
    JEditableTable
  },
  data() {
    return {
      title: '操作',
      visible: false,
      form: this.$form.createForm(this),
      confirmLoading: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      isEdit: false,
      mainLangItems: [], // 主表多语言字段
      subLangItems: {}, // 子表多语言字段
      langList: JSON.parse(this.$ls.get('languageList')), // 当前所有语言
      mainTableAllLangLists: [], // 列表带过来的多语言列表
      mainTableLangLists: {}, // 主表多语言数据结构，带输入值
      sysLanguageList: [], // 要提交的主表信息数组
      subTableLangLists: {} // 子表多语言数据结构，带输入值
    }
  },
  created() {
    this.$bus.$on('langOk', res => {
      let filedName = res.filedName
      let formData = res.formData
      let subLangIndex = res.subLangIndex
      let rows = res.rows
      if (res.isMain) {
        this.setMainTableLangList(filedName, formData)
      } else {
        let tableName = res.tableName
        this.setSubTableLangList(filedName, formData, rows, subLangIndex, tableName)
      }
    })
  },
  mounted() {
    this.getLangItem()
    this.$bus.$on('mainlanguageLists', res => {
      this.mainTableAllLangLists = res
      this.getLangItem()
    })
  },
  methods: {
    // 获取弹框中主表的次语言pop数据
    getMainTablePop(relEntityAttribute) {
      let dataList = []
      let returnList = []
      for (const key in this.mainTableLangLists) {
        if (key == relEntityAttribute) {
          dataList = this.mainTableLangLists[ key ]
        }
      }
      let secondLanguage = JSON.parse(this.$ls.get('secondLanguage')) || []
      dataList.length && dataList.map(item => {
        secondLanguage.length && secondLanguage.map(sItem => {
          if (sItem == item[ 'langType' ]) {
            returnList.push(item)
          }
        })
      })
      return returnList
    },
    /**
     * 输入完多语言，弹框关闭时触发，将值放入主表中，并渲染主Form
     * @param {String} filedName 多语言字段
     * @param {Object} formData 多语言输入值
     */
    setMainTableLangList(filedName, formData) {
      let mainTableItemLists = []
      for (let i = 0; i < this.mainLangItems.length; i++) {
        if (this.mainLangItems[ i ].relEntityAttribute == filedName) {
          for (const key in formData) {
            let mainLangItems = Object.assign({}, this.mainLangItems[ i ])
            this.mainTableLangLists[ filedName ] && this.mainTableLangLists[ filedName ].map(item => {
              if (item.langType == key) {
                mainLangItems.id = item.id
              }
            })
            mainLangItems.langText = formData[ key ]
            mainLangItems.langType = key
            mainTableItemLists.push(mainLangItems)
            if (key == this.$ls.get('language')) {
              // 插入数据
              this.model[ filedName ] = formData[ key ]
              let fieldval = pick(this.model, filedName)
              this.$nextTick(() => {
                this.form.setFieldsValue(fieldval)
              })
            }
          }
        }
      }
      this.mainTableLangLists[ filedName ] = mainTableItemLists
    },
    /**
     * 输入完多语言，弹框关闭时触发，将值放入子表中，并渲染子表form
     * @param {String} filedName
     * @param {Object} formData
     * @param {Boolean} subLangIndex
     * @param {String} tableName
     */
    setSubTableLangList(filedName, formData, rows, subLangIndex, tableName) {
      let subTableItemLists = []
      for (let i = 0; i < this.subLangItems[ tableName ].length; i++) {
        if (this.subLangItems[ tableName ][ i ].relEntityAttribute == filedName) {
          for (const key in formData) {
            let subLangItems = Object.assign({}, this.subLangItems[ tableName ][ i ])
            this.subTableLangLists[ tableName + '-' + filedName + '-' + subLangIndex ] && this.subTableLangLists[ tableName + '-' + filedName + '-' + subLangIndex ].map(item => {
              if (item.langType == key) {
                subLangItems.id = item.id
              }
            })
            subLangItems.langText = formData[ key ]
            subLangItems.langType = key
            subTableItemLists.push(subLangItems)
            if (key == this.$ls.get('language')) {
              // 插入数据
              this.$refs[ this.refKeys[ this.subTable.indexOf(tableName) ] ].setValues([{
                rowKey: rows[ subLangIndex ].id,
                values: {
                  [ filedName ]: formData[ key ]
                }
              }])
            }
          }
        }
      }
      this.subTableLangLists[ tableName + '-' + filedName + '-' + subLangIndex ] = subTableItemLists
      // 把处理完的数据返回给组件，用来回显
      this.$bus.$emit('subTableDataReturn', this.subTableLangLists)
    },
    // 判断是否是多语言输入框，是的话返回true（输入框只读）
    whetherLang(field) {
      if (this.mainLangItems && this.mainLangItems.length) {
        for (let i = 0; i < this.mainLangItems.length; i++) {
          if (this.mainLangItems[ i ].relEntityAttribute == field) {
            return true
          }
        }
      }
    },
    // 判断是否为多语言输入框，是的话触发弹窗
    isLangClick(field, require) {
      if (this.mainLangItems && this.mainLangItems.length) {
        for (let i = 0; i < this.mainLangItems.length; i++) {
          if (this.mainLangItems[ i ].relEntityAttribute == field) {
            /**
             * 触发弹窗
             * field 字段
             * require 是否必填
             * initialValue 初始化回显数据
             */
            this.$bus.$emit('langDialog', { field: field, require: require, isMain: true, initialValue: this.mainTableLangLists[ field ] })
            break
          }
        }
      }
    },
    // 获取多语言字段 relEntityAttribute
    getLangItem() {
      this.mainTable && getLanguageField(this.mainTable).then(res => {
        this.mainLangItems = res.data
        this.mainTableLangLists = {}
        if (this.mainLangItems.length) {
          // // 主表数据回显完成
          // this.mainLangItems.map(item => {
          //     let mainLangItem = []
          //     let mainTableLangLists = this.mainTableAllLangLists || []
          //     if (mainTableLangLists.length) {
          //         mainTableLangLists.map(sItem => {
          //             if (item.relEntityAttribute == sItem.relEntityAttribute) {
          //                 // 将对应的多语言渲染至pop中
          //                 mainLangItem.push(sItem)
          //             }
          //         })
          //     }
          //     this.mainTableLangLists[item.relEntityAttribute] = mainLangItem
          // })
          let mainTableLangLists = this.mainTableAllLangLists || []
          this.mainLangItems.forEach(item => {
            this.mainTableLangLists[ item.relEntityAttribute ] = []
          })
          for (let key in this.mainTableLangLists) {
            for (let i = 0; i < mainTableLangLists.length; i++) {
              if (key == mainTableLangLists[ i ].relEntityAttribute) {
                this.mainTableLangLists[ key ].push(mainTableLangLists[ i ])
              }
            }
          }
        }
      })
      if (this.subTable && this.subTable.length) {
        // 多子表为数组
        this.$bus.$emit('subTableEmit', this.subTable)
        this.subTable.map(item => {
          this.getAllSubItems(item)
        })
      }
    },
    // 获取全部字表的多语言字段信息
    getAllSubItems(subTable) {
      subTable && getLanguageField(subTable).then(res => {
        this.$nextTick(() => {
          this.subLangItems[ subTable ] = res.data
          // 将字表多语言字段传到组件中
          this.$bus.$emit('subLangItems', this.subLangItems)
        })
      })
    },
    /** 获取所有的editableTable实例 */
    getAllTable() {
      if (!(this.refKeys instanceof Array)) {
        throw this.throwNotArray('refKeys')
      }
      let values = this.refKeys.map(key => getRefPromise(this, key))
      return Promise.all(values)
    },
    getAllConfigTable() {
      if (!(this.refConfigKeys instanceof Array)) {
        throw this.throwNotArray('refConfigKeys')
      }
      let values = this.refConfigKeys.map(key => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 遍历所有的JEditableTable实例 */
    eachAllTable(callback) {
      // 开始遍历
      this.getAllTable().then(tables => {
        tables.forEach((item, index) => {
          if (typeof callback === 'function') {
            callback(item, index)
          }
        })
      })
    },
    /** 当点击新增按钮时调用此方法 */
    add() {
      this.$bus.$emit('subTableDataReturn', {})
      if (typeof this.addBefore === 'function') this.addBefore()
      // 默认新增空数据
      let rowNum = this.addDefaultRowNum
      if (typeof rowNum !== 'number') {
        rowNum = 1
        console.warn('由于你没有在 data 中定义 addDefaultRowNum 或 addDefaultRowNum 不是数字，所以默认添加一条空数据，如果不想默认添加空数据，请将定义 addDefaultRowNum 为 0')
      }
      this.eachAllTable((item) => {
        item.add(rowNum)
      })
      if (typeof this.addAfter === 'function') this.addAfter(this.model)
      this.isEdit = false
      this.edit({})
    },
    /** 当点击了编辑（修改）按钮时调用此方法 */
    edit(record) {
      if (typeof this.editBefore === 'function') this.editBefore(record)
      this.visible = true
      this.activeKey = this.refKeys[ 0 ]
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.isEdit = !!this.model.id && true
      if (typeof this.editAfter === 'function') this.editAfter(this.model)
    },
    /** 关闭弹窗，并将所有JEditableTable实例回归到初始状态 */
    close() {
      this.visible = false
      this.eachAllTable((item) => {
        item.initialize()
      })
      this.$emit('close')
    },

    /** 查询某个tab的数据 */
    requestSubTableData(url, params, tab, success) {
      tab.loading = true
      getAction(url, params).then(res => {
        let { result } = res
        let dataSource = []
        if (result) {
          if (Array.isArray(result)) {
            dataSource = result
            let subTable = tab.tableName
            // 多语言回显
            if (this.subLangItems && this.subLangItems[ subTable ] && this.subLangItems[ subTable ].length) {
              // 子表数据回显完成
              this.subLangItems[ subTable ].map(item => {
                if (dataSource.length) {
                  dataSource.map((sItem, sIndex) => {
                    let subLangItem = []
                    if (sItem.sysLanguageList && sItem.sysLanguageList.length) {
                      sItem.sysLanguageList.map(ssItem => {
                        if (item.relEntityAttribute == ssItem.relEntityAttribute && ssItem[ 'buffer1' ] == 'N') {
                          subLangItem.push(ssItem)
                          if (ssItem[ 'langType' ] == this.$ls.get('language', 'zh-cn')) {
                            sItem[ ssItem[ 'relEntityAttribute' ] ] = ssItem[ 'langText' ]
                          }
                        }
                      })
                    }
                    this.subTableLangLists[ subTable + '-' + item.relEntityAttribute + '-' + sIndex ] = subLangItem
                  })
                }
              })
              // 把处理完的数据返回给组件，用来回显
              this.$bus.$emit('subTableDataReturn', this.subTableLangLists)
            }
          } else if (Array.isArray(result.records)) {
            dataSource = result.records
          }
        }
        tab.dataSource = dataSource
        this.getSubTableSubData(dataSource, tab)
        typeof success === 'function'? success(res): ''
      }).finally(() => {
        tab.loading = false
      })
    },
    getSubTableSubData(data, tab) {
    },
    /** 发起请求，自动判断是执行新增还是修改操作 */
    request(formData) {
      let url = this.url.add,
        method = 'post'
      if (this.model.id) {
        url = this.url.edit
        method = 'put'
        formData && formData.length && formData.map(item => {
          if (this.model.operCode) {
            item.operCode = this.model.operCode
          }
        })
      }
      this.confirmLoading = true
      httpAction(url, formData, method).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('ok')
          this.close()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },

    /* --- handle 事件 --- */

    /** ATab 选项卡切换事件 */
    handleChangeTabs(key) {
      // 自动重置scrollTop状态，防止出现白屏
      getRefPromise(this, key).then(editableTable => {
        editableTable.resetScrollTop()
      })
    },
    /** 关闭按钮点击事件 */
    handleCancel() {
      this.close()
    },
    /** 确定按钮点击事件 */
    handleOk() {
      /** 触发表单验证 */
      this.getAllTable().then(tables => {
        /** 一次性验证主表和所有的次表 */
        return validateFormAndTables(this.form, tables)
      }).then(allValues => {
        if (typeof this.classifyIntoFormData !== 'function') {
          throw this.throwNotFunction('classifyIntoFormData')
        }
        // 处理主表多语言数据
        this.sysLanguageList = []
        console.log('%c [ this.mainTableLangLists ]', 'font-size:13px; background:pink; color:#bf2c9f;', this.mainTableLangLists)
        for (const key in this.mainTableLangLists) {
          // 将数组对象展开
          for (let i = 0; i < this.mainTableLangLists[ key ].length; i++) {
            this.mainTableLangLists[ key ][ i ][ 'buffer1' ] = 'Y'
            this.sysLanguageList.push(this.mainTableLangLists[ key ][ i ])
          }
        }
        console.log('this.sysLanguageList', this.sysLanguageList)
        if (this.subTable && this.subTable.length) {
          this.subTable.map((item, index) => {
            let values = allValues.tablesValue[ index ].values
            values.map((sItem, sIndex) => {
              let sysLanguageList = []
              if (this.subTableLangLists && this.subTableLangLists.length) {
                for (const key in this.subTableLangLists) {
                  let table = key.split('-')[ 0 ]
                  let rowIndex = key.split('-')[ 2 ]
                  if (rowIndex == sIndex && item == table) {
                    for (let j = 0; j < this.subTableLangLists[ key ].length; j++) {
                      this.subTableLangLists[ key ][ j ][ 'buffer1' ] = 'N'
                      sysLanguageList.push(this.subTableLangLists[ key ][ j ])
                    }
                  }
                }
              }
              sItem[ 'sysLanguageList' ] = sysLanguageList || []
            })
          })
        }
        let formData = this.classifyIntoFormData(allValues)
        console.log('%c [ formData ]', 'font-size:13px; background:pink; color:#bf2c9f;', formData)
        if (Array.isArray(formData)) {
          // 如果给服务器传的数据是数组，则需要给每个item里的sysLanguageList再插入一次主表的sysLanguageList
          formData.map(item => {
            item.sysLanguageList = item.sysLanguageList && item.sysLanguageList.length && item.sysLanguageList.concat(this.sysLanguageList) || this.sysLanguageList || []
          })
        } else {
          // 如果传给服务器的数据是对象类型，则只给对象外层添加sysLanguageList即可
          formData[ 'sysLanguageList' ] = this.sysLanguageList
        }
        // 发起请求
        return this.request(formData)
      }).catch(e => {
        this.$message.warning(this.$t('tip.theDataIsNotFilledInCompletelyPleaseCheck'))
        if (e.error === VALIDATE_NO_PASSED) {
          // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
          this.activeKey = e.index == null? this.activeKey: this.refKeys[ e.index ]
        } else {
          console.error(e)
        }
      })
    },
    /** 确定按钮点击事件 */
    handleConfigOk() {
      /** 触发表单验证 */
      this.getAllConfigTable().then(tables => {
        /** 一次性验证主表和所有的次表 */
        return validateTables(tables, false)
      }).then(allValues => {
        return this.configRequest(allValues)
      }).catch(e => {
        if (e.error === VALIDATE_NO_PASSED) {
          // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
          this.activeKey = e.index == null? this.activeKey: this.refKeys[ e.index ]
        } else {
          console.error(e)
        }
      })
    },

    /* --- throw --- */

    /** not a function */
    throwNotFunction(name) {
      return `${name} 未定义或不是一个函数`
    },

    /** not a array */
    throwNotArray(name) {
      return `${name} 未定义或不是一个数组`
    },

    emptySelect(str) {
      return str != null && str != 'null' && str.length != 0? str: '无'
    },

    emptyShow(str) {
      return str != null && str != 'null' && str.length != 0? str: ''
    },

    returnNull(str) {
      return str != 'null'? str: null
    },
    setCompanyCode() {
    }

  }
}